import Reflux from "reflux";

export const ActionsJobs = Reflux.createActions({
  getJobs: { asyncResult: true },
  fetchAndSaveJobs: { asyncResult: true },
  createCampaignBasedOnJob: { asyncResult: true },
  openCampaignBasedOnJob: {}
});
